import { useRef, useState } from "react";

function useGetState<T>(initVal?: T): [T, (newVal: T) => void, () => T] {
  const [state, setState] = useState(initVal);
  const ref = useRef(initVal);

  const setStateCopy = (newVal: T) => {
    if (typeof newVal === "function") {
      ref.current = newVal(ref.current);
      setState(ref.current);
    } else {
      ref.current = newVal;
      setState(newVal);
    }
  };
  const getState = () => ref.current;
  return [state as T, setStateCopy, getState as () => T];
}

export default useGetState;
